import Renderer from './Renderer';

export default class PreviewRenderer extends Renderer {
    constructor(canvasElement, svgElement) {
        super(canvasElement, svgElement);
    }
}